import { render } from "./dining.vue?vue&type=template&id=11a9b4ee&scoped=true"
import script from "./dining.vue?vue&type=script&lang=js"
export * from "./dining.vue?vue&type=script&lang=js"

import "./dining.vue?vue&type=style&index=0&id=11a9b4ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11a9b4ee"

export default script